import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  PLATFORM_ID
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet
} from "@angular/router";
// import { MatCardModule } from '@angular/material/card';
// import { DropdownDirective } from 'angular-custom-dropdown';
// import {MessageService} from './message.service'
import { CanonService } from "./canon.service";
import { filter } from "rxjs/operators";

import { BrowserModule } from "@angular/platform-browser";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  @ViewChild("myDropdown")
  // myDropdown: DropdownDirective;
  cuurenturl: any;
  accepts = false;
  cls = false;
  user: any;
  contribute = false;
  item: any;
  key: any;
  v: any;
  a: any;
  myItem: any;
  // ngAfterViewInit(){
  //   this.loading = false;
  title = "TheRightDoctors";
  // message: any;

  // }
  constructor(
    private canonService: CanonService,
    private Route: Router,
    private _router: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.fun();

    // Auto-recover from a stale-HTML/deploy mismatch: after a frontend redeploy the
    // old bundle hashes are gone, so a browser holding OLD cached HTML fails to lazy-
    // load a route chunk ("Failed to fetch dynamically imported module" / MIME text/html).
    // Do a FULL navigation to the target → browser fetches fresh HTML + valid chunks.
    // (sessionStorage guard prevents a reload loop if it still fails.)
    if (isPlatformBrowser(this.platformId)) {
      this.Route.events
        .pipe(filter((e) => e instanceof NavigationError))
        .subscribe((e: any) => {
          const msg = (e && e.error && e.error.message) || "";
          if (/dynamically imported module|ChunkLoadError|Loading chunk|MIME type|text\/html/i.test(msg)) {
            const url = e.url || location.pathname;
            if (sessionStorage.getItem("__chunk_recover") !== url) {
              sessionStorage.setItem("__chunk_recover", url);
              location.assign(url);
            }
          }
        });
      this.Route.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe(() => sessionStorage.removeItem("__chunk_recover"));
    }

    /*this.myItem = localStorage.getItem(this.user);
    console.log('data'+ this.myItem);*/
    this.item = localStorage.getItem("Item 1");
    // console.log('data');
    // console.log(this.item);
    if (this.item == null) {
      this.v = false;
    } else {
      // let myObj = { name: 'Skip'};
      // localStorage.setItem(this.key, JSON.stringify(myObj));
      this.v = true;
    }
    /* this.cuurenturl = this._router.snapshot.url[0].path;*/
    /* this.cuurenturl = this._router.snapshot.data.valueOf();*/
    /* this._router.events.subscribe(event => {

       if (event instanceof NavigationEnd ) {
         console.log("current url",e); // event.url has current url
         // your code will goes here
       }
     });*/
  }
  /*openNow() {
    this.myDropdown.open();
  }*/

  ngOnInit() {
    this.canonService.createCanonicalURL();

    // this.contribute = true ;
    /*this.myDropdown.statusChange()
        .subscribe((status: TOGGLE_STATUS) => {
          let statusValue: String;
          if (status === TOGGLE_STATUS.OPEN) {
            statusValue = 'Opened';
          } else if (status === TOGGLE_STATUS.CLOSE) {
            statusValue = 'Closed';
          }
          console.info(`Dropdown status changed to "${statusValue}".`);
        });*/

    const scrollLevels: { [navigationId: number]: number } = {};
    let lastId = 0;
    let restoredId: number;

    this.Route.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        scrollLevels[lastId] = window.scrollY;
        lastId = event.id;
        restoredId = event.restoredState
          ? event.restoredState.navigationId
          : undefined;
      }

      if (event instanceof NavigationEnd) {
        if (restoredId) {
          // Optional: Wrap a timeout around the next line to wait for
          // the component to finish loading
          window.scrollTo(0, scrollLevels[restoredId] || 0);
        } else {
          window.scrollTo(0, 0);
        }
      }
    });
    // this.messaging.getPermission();
    // this.messaging.receiveMessage();
  }

  fun() {
    this.Route.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .forEach(e => {
        this.cuurenturl = this._router.root.firstChild.snapshot.data["name"];
        this.cdr.markForCheck();
      });
  }

  homeHeader() {
    if (this.cuurenturl === "home") {
      return false;
    } else {
      return true;
    }
  }

  singleHeader() {
    if (this.cuurenturl === "single") {
      return false;
    } else {
      return true;
    }
  }

  accept() {
    this.accepts = true;
    this.key = "Item 1";
    const myObj = { name: "Skip" };
    localStorage.setItem(this.key, JSON.stringify(myObj));
  }
  close() {
    this.accepts = true;
  }
  close_contribute() {
    console.log("Executed !!!");
    this.contribute = true;
  }
}
